/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  border-radius: 4px;
  min-height: 12px;
  min-width: 40px;
  background-color: #E0E0E0;
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;

  @keyframes pulse {
    0%, 100% {
      opacity: 1;
    }
    50% {
      opacity: .5;
    }
  }

  ${({ width }) => width && `
    width: ${width};
  `}

  ${({ height }) => height && `
    height: ${height};
  `}

  ${({ color }) => color && `
    background-color: ${color};
  `}
`
